import { gql } from 'apollo-angular';

// Asks for access roles, which an API from before admin roles cannot answer;
// the page falls back to GET_ADMINS_LEGACY there.
export const GET_ADMINS = gql`
    query admins($page: Int, $querySearch: String) {
        admins(page: $page, querySearch: $querySearch) {
            adminId
            name
            email
            dateCreated
            status
            isVerify
            isNew
            createdBy
            dateUpdated
            accessLevel
            accessRoles {
                roleId
                name
                isSystem
            }
        }
    }
`; 
export const GET_ADMINS_LEGACY = gql`
    query admins($page: Int, $querySearch: String) {
        admins(page: $page, querySearch: $querySearch) {
            adminId
            name
            email
            dateCreated
            status
            isVerify
            isNew
            createdBy
            dateUpdated
        }
    }
`;
